import { React, FormControl, Select, MenuItem, SelectChangeEvent, FormControlProps, Typography } from '../../utils/globalImports';
import EllipsisWithConditionalTooltip from './EllipsisWithConditionalTooltip';
interface Option {
  value: string | number; // The value for the dropdown option
  text: string;           // The display text for the dropdown option
}

interface CustomDropdownNumberProps {
  value: string | number; // The current selected value
  onChange: (event: SelectChangeEvent<string | number>) => void; // Callback function for value change
  onClick?: () => void;
  sx?: object; // Allow custom styling
  label: string;                // The label text for the dropdown
  options?: Option[];           // Optional: Array of options (default: ['Active', 'InActive', 'Both'])
  formControlProps?: FormControlProps;   // Optional: Props for FormControl component
  requiredLabel?: boolean;
  required?: boolean;
  disable?: boolean;
  disableSorting?: boolean;
}

const CustomDropdownNumber: React.FC<CustomDropdownNumberProps> = ({
  value,
  onChange,
  onClick,
  sx,
  label,
  options = [
    { value: 1, text: 'Active' },
    { value: 0, text: 'Inactive' },
  ],
  formControlProps,
  requiredLabel = false,
  required = true,
  disable,
  disableSorting = false
}) => {

  /** ✅ SORT ONLY IF disableSorting IS FALSE */
  const sortedOptions = disableSorting
    ? options
    : options.slice().sort((a, b) => a.text.localeCompare(b.text));

  return (
    <FormControl fullWidth {...formControlProps}>
      {requiredLabel && (
        <Typography
          variant="subtitle1"
          sx={{ color: '#1e66ab', fontSize: 14, fontWeight: 500, ml: 1 }}
        >
          {label}
          {required && <span style={{ color: 'red' }}>*</span>}
        </Typography>
      )}

      <Select
        value={value}
        onChange={onChange}
        onClick={onClick}
        disabled={disable}
        displayEmpty   // ✅ IMPORTANT
        renderValue={(selected) => {
          const selectedOption = options.find(
            (opt) => opt.value === selected
          );
          if (selected === "") {
            return (
              <span style={{ color: '#9e9e9e' }}>
                {label}
              </span>
            );
          }

          // const selectedOption = options.find(
          //   (opt) => opt.value === selected
          // );

          return selectedOption?.text || selected;
        }}
        sx={{
          ...sx,
          borderRadius: '20px',
          '& .MuiSelect-select': {
            padding: '10px 15px',
            fontSize: '14px',
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 200,
              maxWidth: 200,
            },
          },
        }}
      >
        {/* 🔹 Placeholder item */}
        <MenuItem value="" disabled>
          {label}
        </MenuItem>

        {/* 🔹 Options */}
        {sortedOptions.map((option, index) => (
          <MenuItem key={index} value={option.value}>
            <EllipsisWithConditionalTooltip>
              {option.text}
            </EllipsisWithConditionalTooltip>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomDropdownNumber;